import React, { ReactElement, useMemo, useState } from 'react';
import { MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { useNavigate, useParams } from 'react-router-dom';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { FieldRenderProps, Form, FormElement } from '@progress/kendo-react-form';
import { Avatar } from '@progress/kendo-react-layout';
import { toast } from 'react-toastify';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import * as EventSlice from '../../../../../../slices/EventSlice';
import { IStaff } from '../../../../../../types/IStaff';
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Checkbox, TextArea } from '@progress/kendo-react-inputs';
import IEvent from '../../../../../../types/Ticket/IEvent';

interface EmailFormProps {
    onsubmitted?: () => void
    onclosed?: () => void
    showSaveButton?: boolean
    formName?: string
}

const EventForm: React.FC<EmailFormProps> = (props) => {
    const { ticketId } = useParams();
    const eventDetails = useReduxSelector(state => state.eventDetails);
    const dispatch = useReduxDispatch();
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const [filter, setFilter] = useState<FilterDescriptor>({ operator: 'contains' })
    let { data: ToList, isFetching: toLoading } = UserApi.useSearchContactsQuery(filter?.value, { skip: !filter?.value || filter?.value?.length < 3 });
    const [createEvent, { isLoading: sendingEmail, error: sendEmailError }] = TicketApi.useCreateEventMutation();
    const filteredTo = useMemo(() => ToList?.length && filter?.value ? filterBy(ToList?.slice(), filter) : ToList, [filter, ToList]);
    const { data: ticket } = TicketApi.useGetTicketDetailsQuery({ ticketId: parseInt(ticketId) })
    const { data: defaultFormState, isLoading } = TicketApi.useGetEmailConfigQuery(parseInt(ticketId), { skip: userProfile?.Features?.External_Interface });

    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        //console.log('Filter', event);
        //setStaff(filterBy(staffList?.slice(), event.filter));
        setFilter(event.filter);
    }

    //Load the default form state
    React.useEffect(() => {
        if (ticket) {
            dispatch(EventSlice.setEventTicketId(parseInt(ticketId)));

            //set default start date which is on the next hour
            const startDate = new Date();
            startDate.setHours(startDate.getHours() + 1);
            startDate.setMinutes(0, 0, 0);
            dispatch(EventSlice.setStart(startDate.toISOString()));
            startDate.setHours(startDate.getHours() + 1);
            dispatch(EventSlice.setEnd(startDate.toISOString()));

            //Add  to ticket contact
            let ToList = [{ Full_Name: ticket.Contact.FullName, ID: ticket.Contact.ID } as IStaff];

            //Add each assigned user
            ticket.Call_Assignment.forEach((user) => {
                ToList.push({ Email: '', Full_Name: user.Contact_Name, ID: user.Contact_Id } as IStaff);
            });
            dispatch(EventSlice.setEventTo(ToList));

        }
    }, [ticket]);


    const handleSend = async (values, event) => {
        event.preventDefault();
        try {
            //create a new share item            
            console.log('SENDING', eventDetails);

            //Remove time if it is all day
            let saveEvent = { ...eventDetails };
            if (eventDetails.AllDay) {
                let startNoTime = new Date(eventDetails.StartDate);
                startNoTime.setHours(0, 0, 0, 0);
                saveEvent.StartDate = startNoTime.toISOString();
                let endtNoTime = new Date(eventDetails.StartDate);
                endtNoTime.setHours(0, 0, 0, 0);
                saveEvent.EndDate = endtNoTime.toISOString();
            }


            createEvent({ ...saveEvent, RecipientIds: eventDetails.To.map(t => t.ID), To: null }).unwrap()
                .then(() => {

                    //nom nom toast
                    //toast.success('Email sent successfully');

                    //reset the form
                    dispatch(EventSlice.resetEventForm({} as IEvent));

                    //console.log('sendEmailAction submitted', props.onsubmitted);

                    //go back
                    props.onsubmitted && props.onsubmitted();

                }).catch((error) =>
                    toast.error('Error creating event: ' + JSON.stringify(error))
                )
        } catch (error) {
            console.error('Error creating event:', error);
            toast.error('Error creating event: ' + JSON.stringify(error));
        }

        return false;
    };

    ///Render the 'chip' tag
    const renderTag = (tagData, tag: ReactElement) => {
        var data = tagData.data[0] as IStaff;
        var imgUrl = data?.Profile_Image_Path;
        var showIMage = tagData?.data[0].img_class != 'n';
        var customElement = <div key={data.ID} className='k-hbox' title={data.Full_Name + ' - ' + data.Company_Name}>
            {showIMage && <Avatar size='small' rounded='full' className='user-profile-image ' >
                {imgUrl?.indexOf('/images') == 0 ? <img src={`.${imgUrl}`} alt="Profile" width="25" height="25" /> : (imgUrl ? <img src={imgUrl} alt="Profile" width="25" height="25" /> : <img src={'./images/placeholder.png'} alt="Profile" width="25" height="25" />)}
            </Avatar>}
            <div className='name'>{data.Full_Name} {data.Email ? `<${data.Email}>` : ''}</div>
        </div>

        return React.cloneElement(tag, tag.props, [
            (customElement) as any,
            tag.props.children
        ]);
    }
    const renderItem = (li, itemProps) => {
        var data = itemProps.dataItem as IStaff;
        var showIMage = true//data.img_class != 'n';
        var item = (

            <div className="k-hbox" key={data.ID}>
                {showIMage && <Avatar size='medium' rounded='full' className='user-profile-image' >
                    {data.Profile_Image_Path?.indexOf('/images') == 0 ? <img src={`.${data.Profile_Image_Path}`} alt="Profile" width="30" height="30" /> : (data.Profile_Image_Path ? <img src={data.Profile_Image_Path} alt="Profile" width="30" height="30" /> : <img src={'./images/placeholder.png'} alt="Profile" width="30" height="30" />)}
                </Avatar>}
                <div className='ms-1 flex-nope'>
                    <div className='flex'>{data.Full_Name} - {data.Company_Name}</div>
                    <small className='user-sub-title' title={data.Email ?? ''}> {data.Email ? `<${data.Email}>` : ''}</small>
                </div>
            </div>)

        return React.cloneElement(li, li.props, item);
    };

    const handleToChange = (event: MultiSelectChangeEvent) => {
        //console.log('handleToChange', event);

        const values = event.target.value;
        //console.log('values', values);

        dispatch(EventSlice.setEventTo(validateEmails(values)));
    };

    const validateEmails = (values: IStaff[]) => {
        //Check for custom value which means ID is null and Full_Name is the email address OR the email address and name.
        //use Regex to extract the email address from between the < > or just use the Full_Name
        //const values = event.target.value;
        const lastItem = { ...values[values.length - 1] };
        if (values.length > 0 && lastItem && lastItem.ID == null && !lastItem.Email) {
            values.pop();
            var Regex = /<([^>]+)>/;
            var foundEmail = Regex.exec(lastItem?.Full_Name);

            //var name = lastItem?.Full_Name;
            if (foundEmail) {
                lastItem.Email = foundEmail[foundEmail.length - 1];
                //THe name should be the start of the string to the first < character
                lastItem.Full_Name = lastItem?.Full_Name.substring(0, lastItem?.Full_Name.indexOf('<')).trim();
            } else {
                lastItem.Email = lastItem.Full_Name;
                lastItem.Full_Name = '';
            }

            //use a regex to make sure the email is valid
            var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            var isValid = emailRegex.test(lastItem.Email);
            console.log('isValid', isValid, lastItem);
            if (!isValid) return;

            values.push(lastItem);
        }

        return values;
    }

    const onMount = (event) => {
        //Set focus on the element in the iframe with 'k-content' as the class
        const iframeDocument = event.dom.ownerDocument;
        const element = iframeDocument.querySelector('.k-content');
        //wait 100ms
        // setTimeout(() => {
        //     if (element) element.focus();
        //     console.log('onMount', element);
        // }, 1000);


    };

    const formValidator = (values) => {
        let val = {
            ...(eventDetails.To?.length < 1 && { "to": `At least one recipient is required in the TO field` }),
            ...(!eventDetails.StartDate?.length && { "startDate": `Start date is required` }),
            ...(!eventDetails.EndDate?.length && { "endDate": `End date is required` }),
            ...(eventDetails.StartDate >= eventDetails.EndDate && { "date": `End date must be after Start date` }),
            ...(!eventDetails.Notes && { "body": `Event description is required` }),
        }

        //console.log('formValidator', val, formState?.email?.HTML_Note, values);

        if (Object.keys(val).length > 0) return val;
        return null;
    }


    // const onIframeInit = (ev: EditorIFrameInitEvent) => {

    //     //located in public folder
    //     const stylesheets = [
    //         './style/emailTemplate.css'
    //     ];

    //     stylesheets.forEach(href => {
    //         if (href && ev.iframe && ev.iframe.contentWindow) {
    //             const iframeDocument = ev.iframe.contentWindow.document;
    //             const linkElementWithiFrameStyles = iframeDocument.createElement('link');
    //             linkElementWithiFrameStyles.rel = 'stylesheet';
    //             linkElementWithiFrameStyles.type = 'text/css';
    //             linkElementWithiFrameStyles.href = href;
    //             iframeDocument.head.appendChild(linkElementWithiFrameStyles);
    //         }
    //     });
    // }

    //Not for end users
    if (userProfile?.Features.External_Interface) return <></>;

    return (
        <div className='position-relative'>
            {(sendingEmail || isLoading) && <PartialSpinny />}
            <Form id={props.formName || 'new-event-form'} onSubmit={handleSend} validator={formValidator} ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement className='w-100 d-flex flex-column email-action-form p-1 '>
                        {formRenderProps.errors && Object.keys(formRenderProps.errors).length > 0 && (
                            <div className="k-messagebox k-messagebox-error p-2 m-0" role="alert">
                                {Object.keys(formRenderProps.errors).map((key, index) => (
                                    <div key={index}>{formRenderProps.errors[key]}</div>
                                ))}
                            </div>
                        )}
                        {/* TO */}
                        <div className='row g-1 align-items-center'>
                            <label className='col-1'>To:</label>
                            <div className='col-11'>
                                <div className='w-100 inline-block' >
                                    <MultiSelect id='To' name='To' size='large' value={eventDetails.To} onChange={handleToChange} tagRender={renderTag} itemRender={renderItem} placeholder='To: Type 3 or more characters to search...' filterable={true} allowCustom={true}
                                        popupSettings={{ className: 'z500', height: 400 }} onFilterChange={onFilter} data={filteredTo} dataItemKey="ID" textField="Full_Name" loading={toLoading} />
                                </div>
                            </div>
                        </div>
                        {/* Start */}
                        <div className='row g-1 align-items-center'>
                            <label className='col-1'>Start:</label>
                            <div className='col-auto'>
                                {eventDetails.AllDay
                                    ? <DatePicker width={200} value={new Date(eventDetails.StartDate)} onChange={(e) => dispatch(EventSlice.setStart(e.value.toISOString()))} />
                                    : <DateTimePicker width={200} value={new Date(eventDetails.StartDate)} onChange={(e) => dispatch(EventSlice.setStart(e.value.toISOString()))} />
                                }
                            </div>
                            <div className='col'>
                                <Checkbox checked={eventDetails.AllDay} onChange={(e) => {
                                    dispatch(EventSlice.setAllDay(e.target.value === true));
                                }} label='All Day?' />
                            </div>
                        </div>
                        {/* End */}
                        <div className='row g-1 align-items-center'>
                            <label className='col-1'>End:</label>
                            <div className='col'>
                                {eventDetails.AllDay
                                    ? <DatePicker required width={200} value={new Date(eventDetails.EndDate)} onChange={(e) => dispatch(EventSlice.setEnd(e.target.value.toISOString()))} />
                                    : <DateTimePicker required width={200} value={new Date(eventDetails.EndDate)} onChange={(e) => dispatch(EventSlice.setEnd(e.target.value.toISOString()))} />
                                }
                            </div>
                        </div>
                        <div className='row g-1'>
                            <div className='inline-block col-1 pl-2'></div>
                            <div className={`inline-block w-full align-top col-12 col-lg-11`}>
                                <TextArea id='body' name='body' rows={5} placeholder='Description' value={eventDetails.Notes} onChange={(e) => dispatch(EventSlice.setEventNotes(e.target.value))} />
                                {/* <Editor
                                    onIFrameInit={onIframeInit}
                                    contentStyle={{ height: '270px' }}
                                    onChange={(e) => dispatch(EventSlice.setNotes(e.html))}
                                    value={eventDetails.Notes || ''}
                                    tools={MobileTools}
                                    onMount={onMount}
                                /> */}
                            </div>
                        </div>
                    </FormElement >
                )
                }></Form >

        </div >


    );
};

export default EventForm;